import React, { ReactElement } from 'react';
import { SecurityOverviewPageRoute } from 'routes/security.routes';
import { WatchlistType } from 'typings/marketWatch.type';
import i18n from 'locales/fa.json';
import { StyledDiv, StyledLink, StyledSignedText } from 'theme/commonStyled';
import theme from 'theme';
import {
  fixLocaleString,
  persianSorter,
  push,
  sorter,
  toSummarize,
} from './common.util';
import { ColumnType } from 'typings/common.type';
import { signedIcon } from './component.util';

export const COLUMNS: ColumnType[] = [
  {
    title: i18n.watchList.symbol,
    dataIndex: 'symbol',
    width: 80,
    sorter: persianSorter('symbol'),
    render: (value, row) => (
      <StyledDiv
        display="flex"
        justifyContent="flex-start"
        gap={6}
        alignItems="center"
      >
        <StyledDiv
          width={4}
          height={4}
          mr={8}
          data-cy={`open-${row.state === i18n.security.overview.states.open}`}
          bg={
            row.state === i18n.security.overview.states.open
              ? 'grass80'
              : 'rose80'
          }
          borderRadius={theme.radii.full}
        />
        <StyledLink
          textAlign="right"
          width={45}
          onClick={push(SecurityOverviewPageRoute(row.symbol_12chars))}
          fontFamily="body"
        >
          {value}
        </StyledLink>
      </StyledDiv>
    ),
  },
  {
    title: i18n.watchList.lastPrice,
    dataIndex: 'last_price',
    width: 100,
    sorter: sorter('last_price'),
    render: (value, row): ReactElement => (
      <StyledDiv>
        <StyledDiv color="ash90" fontFamily="body">
          {fixLocaleString(value)}
        </StyledDiv>
        {row.last_price_percentage_changes && row.trades_volume ? (
          <StyledSignedText value={row.last_price_percentage_changes}>
            {signedIcon(Number(row.last_price_percentage_changes))}
            {fixLocaleString(row.last_price_percentage_changes)} %
          </StyledSignedText>
        ) : null}
      </StyledDiv>
    ),
  },
  {
    title: i18n.watchList.closePrice,
    dataIndex: 'close_price',
    width: 100,
    sorter: sorter('close_price'),
    render: (value, row): ReactElement => (
      <StyledDiv>
        <StyledDiv fontFamily="body" color="ash90">
          {fixLocaleString(value)}
        </StyledDiv>
        {row.close_price_percentage_changes && row.trades_volume ? (
          <StyledSignedText
            hasBg={false}
            isCenter
            value={row.close_price_percentage_changes}
          >
            {signedIcon(Number(row.close_price_percentage_changes))}
            {fixLocaleString(row.close_price_percentage_changes)} %
          </StyledSignedText>
        ) : null}
      </StyledDiv>
    ),
  },
  {
    title: i18n.watchList.tradesVolume,
    dataIndex: 'trades_volume',
    width: 110,
    sorter: sorter('trades_volume'),
    render: (value) => (
      <StyledDiv fontFamily="body" color="ash90">
        {fixLocaleString(value)}
      </StyledDiv>
    ),
  },
  {
    title: i18n.watchList.tradesValue,
    dataIndex: 'trades_value',
    width: 120,
    defaultSortOrder: 'descend',
    sorter: sorter('trades_value'),
    render: (value): ReactElement => (
      <StyledDiv fontFamily="body" color="ash90" direction="ltr">
        {toSummarize(value)}
      </StyledDiv>
    ),
  },
];

export const SWITCH_TITLES = [
  { value: false, label: i18n.watchList.filter.showAll },
  { value: true, label: i18n.watchList.filter.showOpen },
];

export const updateWatchList = (
  basketList: WatchlistType[],
  newList: WatchlistType,
): WatchlistType[] =>
  basketList.map((item) => (item.id === newList.id ? newList : item));
